import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import profileBg from '../../../assets/images/auth-one-bg.jpg';
import { alertSuccess, generateColor } from '../../../helpers/general';
import { useDispatch, useSelector } from 'react-redux';
import Address from './Address';
import UserDetails from './UserDetails';

import TransactionTable from './Transactions/TransactionTable';
import Dashboard from './Dashboard/Dashboard';
import { getAllConfigs } from '../../../actions/promotion/generals';
import { getMemberDetail, listMembers } from '../../../actions/members/list';
import { If, Then } from 'react-if';
import { getRewardsMaster } from '../../../actions/rewards';
import RewardTransactionTable from '../../Reward/RewardTransactions/TransactionTable';
import Barcode from 'react-barcode';
import CountUp from 'react-countup';
import { formatDate } from '../../../helpers/formatDate';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import UserAttributes from './Dashboard/UserAttributes';
import StoreVisits from './StoreVisits';
import RedemptionStream from '../../Promotion/PromotionRedemption/RedemptionStream';
/**
 *
 * @returns
 */
const Profile = () => {
  document.title = 'Profile';
  let params = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [fields, setFields] = useState([]);
  const [member, setMember] = useState({});
  const [configs, setSelectedConfig] = useState(null);
  const [configsLabels, setSelectedConfigLabels] = useState(null);
  const [rewards, setRewards] = useState([]);
  const [rewardTypeTabs, setRewardTypeTabs] = useState([]);
  const [activeTab, setActiveTab] = useState('dashboard');

  const getConfigs = async () => {
    try {
      setIsLoading(true);
      const { data } = await getAllConfigs({
        configName: 'members,members-localization,members-lifecycle',
        configEnv: process.env.NODE_ENV,
        pageOffset: Math?.max(0 - 1, 0),
        pageSize: 1000,
      });

      const res = await getRewardsMaster(data);
      setRewards(res?.data?.rewardTypes || []);

      setFields([...data]);
      const fieldConfigs = {};
      const fieldConfigsLabels = {};

      data.map((item) => {
        let fieldType = null;
        let fieldLabel = null;
        let isLoyaltyCardUniqueID = false;
        let isDisplayInProfile = false;
        let fieldId = null;

        item.values.forEach((value) => {
          if (value.fieldCode === 'fieldType') {
            fieldType = value.fieldValue;
          }
        });
        if (fieldType === 'OtherField') {
          item.values.forEach((value) => {
            if (value.fieldCode === 'isLoyaltyCardUniqueID') {
              if (!fieldConfigs['loyaltyCardNumbers']) {
                fieldConfigs['loyaltyCardNumbers'] = [];
              }
              isLoyaltyCardUniqueID = true;
            }
            if (value.fieldCode === 'displayInProfile') {
              if (!fieldConfigs['displayInProfile']) {
                fieldConfigs['displayInProfile'] = [];
              }
              isDisplayInProfile = true;
            }
            if (value.fieldCode === 'configLabel') {
              fieldLabel = value.fieldValue;
            }
            if (value.fieldCode === 'fieldId') {
              fieldId = value.fieldValue;
            }
          });
        }
        item.values.forEach((value) => {
          if (value.fieldCode === 'fieldId') {
            if (isDisplayInProfile) {
              fieldConfigs['displayInProfile'].push(value.fieldValue);
            }
            if (isLoyaltyCardUniqueID) {
              fieldConfigs['loyaltyCardNumbers'].push(value.fieldValue);
            }
            if (fieldType !== 'OtherField') {
              fieldConfigs[fieldType] = value.fieldValue;
            }
          }
          if (value.fieldCode === 'configLabel') {
            fieldConfigsLabels[fieldId] = value.fieldValue;
          }
        });
      });
      setSelectedConfig(fieldConfigs);
      setSelectedConfigLabels(fieldConfigsLabels);
      // console.log('fieldConfigs', fieldConfigs, data, fieldConfigsLabels);
      const member = await getMemberDetail({ id: params.id });
      setMember(member);

      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getConfigs();
  }, []);

  //

  // form validation

  setTimeout(() => {
    setIsLoading(false);
  }, 3500);
  /**
   *
   * @param {*} tab
   */
  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    if (member?.rewards) {
      const rewardTabs = Object.keys(member?.rewards)?.map((key) => ({
        label: key?.replaceAll('_', ' '),
        id: member?.rewards?.[key]?.[member?.country]?.id,
        rewardId: member?.rewards?.[key]?.[member?.country]?.id,
        rewardTypeId: key,
      }));

      setRewardTypeTabs([...rewardTabs]);
    }
  }, [member]);

  const tabs = [
    { label: 'Dashboard', id: 'dashboard' },
    { label: 'Attributes', id: 'attributes' },
    { label: 'Purchases', id: 'purchases' },
    { label: 'Store Visits', id: 'storeVisits' },
    ...rewardTypeTabs,
    { label: 'Wallet Transactions', id: 'walletTransactions' },
    { label: 'Address', id: 'address' },
  ];
  const navigateToDashboard = () => {
    window.location.href = '/members/list';
  };

  return (
    <>
      <div className="page-content p-4" style={{ background: '#f7f8fa' }}>
        <div className="d-flex gap-3 align-items-center mx-n4 mt-n4 mb-4">
          <div
            className="bg-white rounded-4 shadow-sm border border-light px-3 py-2 cursor-pointer d-flex align-items-center gap-2"
            style={{ minWidth: 90, fontSize: 14, fontWeight: 500 }}
            onClick={navigateToDashboard}
          >
            <i className="ri-arrow-left-line"></i>
            <span>Back</span>
          </div>
          <div className="flex-grow-1">
            <div
              className="bg-white rounded-4 shadow-sm border border-light px-4 py-2 d-flex align-items-center"
              style={{ minHeight: 54 }}
            >
              <h4
                className="m-0 fw-semibold"
                style={{ fontSize: 20, letterSpacing: 0.1 }}
              >
                Customer Profile
              </h4>
            </div>
          </div>
          <div className="ms-3">
            <div
              className="bg-white rounded-4 shadow-sm border border-light px-2 py-1 d-flex align-items-center"
              style={{ minWidth: 230 }}
            >
              <Flatpickr
                size="sm"
                className="form-control border-0 bg-transparent fs-13 px-2"
                style={{
                  minWidth: 120,
                  background: 'transparent',
                  boxShadow: 'none',
                }}
                options={{
                  mode: 'range',
                  dateFormat: 'd M, Y',
                  defaultDate: ['01 Jan 2022', '31 Jan 2022'],
                }}
              />
              <span className="ms-2" style={{ color: '#8e9ab0', fontSize: 18 }}>
                <i className="ri-calendar-2-line"></i>
              </span>
            </div>
          </div>
        </div>
        {/* <div className="position-relative mx-n4 ">
          <div className="profile-wid-bg profile-setting-img">
            <img src={profileBg} className="profile-wid-img" alt="" />
            <div className="overlay-content">
              <div className="text-end p-3">
                <div className="p-0 ms-auto rounded-circle profile-photo-edit">
                  <input
                    id="profile-foreground-img-file-input"
                    type="file"
                    className="profile-foreground-img-file-input"
                  />
                  <label
                    for="profile-foreground-img-file-input"
                    className="profile-photo-edit btn btn-light"
                  >
                    <i className="ri-image-edit-line align-bottom me-1"></i>{' '}
                    Change Cover
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <Row>
          <Col
            md={3}
            className="pt-3"
            style={{ borderRight: '1px solid #e9ecef' }}
          >
            <div className="pe-3">
              <If condition={member?._id}>
                <Then>
                  <div className="bg-white rounded-4 shadow-sm border border-light p-3">
                    <UserDetails
                      member={member}
                      configs={configs}
                      rewards={rewards}
                      configsLabels={configsLabels}
                    />
                  </div>
                </Then>
              </If>
            </div>
          </Col>
          <Col md={9}>
            <div className="ps-1">
              <div className="bg-transparent rounded-4  border border-light">
                <Nav
                  className="nav-tabs-custom px-3 pt-3"
                  role="tablist"
                  style={{ borderBottom: '1px solid #f1f3f6' }}
                >
                  {tabs?.map((tab) => {
                    const isActive = activeTab === tab?.id;
                    return (
                      <NavItem className="me-2 mb-0" style={{ fontSize: 15 }}>
                        <NavLink
                          className={classnames('text-capitalize px-1 py-2', {
                            active: isActive,
                          })}
                          style={{
                            border: 'none',
                            background: 'none',
                            boxShadow: 'none',
                            fontWeight: isActive ? 600 : 400,
                            color: isActive ? '#2d3748' : '#8e9ab0',
                            borderBottom: isActive
                              ? '3px solid #2e5aac'
                              : '3px solid transparent',
                            borderRadius: 0,
                            marginBottom: -1,
                          }}
                          onClick={() => {
                            tabChange(tab?.id);
                          }}
                        >
                          {tab?.label}
                        </NavLink>
                      </NavItem>
                    );
                  })}
                </Nav>
                <TabContent activeTab={activeTab} className="py-4 px-3">
                  <TabPane tabId="dashboard">
                    <div className="bg-transparent rounded-4  border border-light pt-1 mb-3">
                      <Dashboard member={member} setActiveTab={setActiveTab} />
                    </div>
                  </TabPane>
                  <TabPane tabId="attributes">
                    <div className="bg-transparent rounded-4 border border-light pt-1 mb-3">
                      <UserAttributes
                        member={member}
                        configs={configs}
                        configsLabels={configsLabels}
                        setActiveTab={setActiveTab}
                      />
                    </div>
                  </TabPane>
                  {/*  Transactions */}
                  <TabPane tabId="purchases">
                    <div className="bg-white rounded-4 shadow-sm border border-light pt-1 mb-3">
                      <If condition={member?._id}>
                        <RedemptionStream member={member} />
                      </If>
                    </div>
                  </TabPane>
                  {/*  Journey  */}
                  <TabPane tabId="storeVisits">
                    <div className="bg-white rounded-4 shadow-sm border border-light p-3 mb-3">
                      <StoreVisits member={member} />
                    </div>
                  </TabPane>
                  {rewardTypeTabs?.map((rt) => {
                    return (
                      <TabPane tabId={rt?.id}>
                        <div className="bg-white rounded-4 shadow-sm border border-light p-3 mb-3">
                          <Row>
                            <Col md={4}>
                              <div
                                className="rounded-4 shadow-sm border border-light p-3 h-100"
                                style={{
                                  background: '#f8fafd',
                                  minHeight: 140,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    <span
                                      className="fw-semibold text-capitalize me-2"
                                      style={{ fontSize: 15 }}
                                    >
                                      {rt?.rewardTypeId?.replaceAll('_', ' ')}
                                    </span>
                                    <p
                                      className="mb-0"
                                      style={{ fontSize: 13, color: '#6c757d' }}
                                    >
                                      {
                                        member?.rewards?.[rt?.rewardTypeId]?.[
                                          member?.country
                                        ]?.tierName
                                      }
                                    </p>
                                    {member?.rewards?.[rt?.rewardTypeId]?.[
                                      member?.country
                                    ]?.tierExpiryAt && (
                                      <span
                                        className="d-block mt-1"
                                        style={{
                                          fontSize: 11,
                                          color: '#8e9ab0',
                                        }}
                                      >
                                        {`Tier Expiry: ${formatDate(
                                          member?.rewards?.[rt?.rewardTypeId]?.[
                                            member?.country
                                          ]?.tierExpiryAt,
                                          'MM/DD/YYYY'
                                        )}`}
                                      </span>
                                    )}
                                  </div>
                                  <Barcode
                                    value={
                                      member?.rewards?.[rt?.rewardTypeId]?.[
                                        member?.country
                                      ]?.id
                                    }
                                    background="#ffffff00"
                                    height={31}
                                    width={1.2}
                                    fontSize={15}
                                  />
                                </div>
                              </div>
                            </Col>
                            <Col md={8}>
                              <Row>
                                <Col md={4} className="px-2 py-0">
                                  <div
                                    className="rounded-4 shadow-sm border border-light p-3 h-100"
                                    style={{
                                      background: '#f8fafd',
                                      minHeight: 90,
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <p
                                      className="fw-medium mb-0 text-center pb-1"
                                      style={{ color: '#8e9ab0', fontSize: 13 }}
                                    >
                                      Spendable
                                    </p>
                                    <div
                                      className="fw-bold text-center"
                                      style={{ fontSize: 22, color: '#2d3748' }}
                                    >
                                      <CountUp
                                        start={0}
                                        end={
                                          member?.rewards?.[rt?.rewardTypeId]?.[
                                            member?.country
                                          ]?.points?.spendable || 0
                                        }
                                        decimals={0}
                                        duration={2}
                                        suffix=" pts"
                                      />
                                    </div>
                                  </div>
                                </Col>
                                <Col md={4} className="px-2 py-0">
                                  <div
                                    className="rounded-4 shadow-sm border border-light p-3 h-100"
                                    style={{
                                      background: '#f8fafd',
                                      minHeight: 90,
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <p
                                      className="fw-medium mb-0 text-center pb-1"
                                      style={{ color: '#8e9ab0', fontSize: 13 }}
                                    >
                                      Hold
                                    </p>
                                    <div
                                      className="fw-bold text-center"
                                      style={{ fontSize: 22, color: '#2d3748' }}
                                    >
                                      <CountUp
                                        start={0}
                                        end={
                                          member?.rewards?.[rt?.rewardTypeId]?.[
                                            member?.country
                                          ]?.points?.earningHold || 0
                                        }
                                        decimals={0}
                                        duration={2}
                                        suffix=" pts"
                                      />
                                    </div>
                                  </div>
                                </Col>
                                <Col md={4} className="px-2 py-0">
                                  <div
                                    className="rounded-4 shadow-sm border border-light p-3 h-100"
                                    style={{
                                      background: '#f8fafd',
                                      minHeight: 90,
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <p
                                      className="fw-medium mb-0 text-center pb-1"
                                      style={{ color: '#8e9ab0', fontSize: 13 }}
                                    >
                                      Redeemed
                                    </p>
                                    <div
                                      className="fw-bold text-center"
                                      style={{ fontSize: 22, color: '#2d3748' }}
                                    >
                                      <CountUp
                                        start={0}
                                        end={
                                          member?.rewards?.[rt?.rewardTypeId]?.[
                                            member?.country
                                          ]?.points?.redeemed || 0
                                        }
                                        decimals={0}
                                        duration={2}
                                        suffix=" pts"
                                      />
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                        <div className="bg-white rounded-4 shadow-sm border border-light p-3 mb-3">
                          <RewardTransactionTable
                            rewardTypeId={rt?.rewardTypeId}
                            rewardId={rt?.rewardId}
                            member={member}
                          />
                        </div>
                      </TabPane>
                    );
                  })}
                  {/*  wallet Transactions */}
                  <TabPane tabId="walletTransactions">
                    <div className="bg-white rounded-4 shadow-sm border border-light p-3 mb-3">
                      <TransactionTable />
                    </div>
                  </TabPane>
                  {/*  Address */}
                  <TabPane tabId="address">
                    <div className="bg-white rounded-4 shadow-sm border border-light p-3 mb-3">
                      <Address />
                    </div>
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Profile;
